import React from 'react';
import { Shield } from 'lucide-react';

/**
 * Admin badge — teal shield + "Admin" pill rendered next to admin display names.
 */
const AdminBadge = React.forwardRef(({ show, withLabel = true, size = 12, light = false, className = '', ...rest }, ref) => {
  if (!show) return null;
  return (
    <span
      ref={ref}
      aria-label="Sirati Admin"
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full font-semibold ${light ? 'bg-white/15 text-white text-xs' : 'bg-primary/15 text-primary text-[10px]'} ${className}`}
      data-testid="admin-badge"
      {...rest}
    >
      <Shield aria-hidden="true" style={{ width: size, height: size }} />
      {withLabel && <span>Admin</span>}
    </span>
  );
});
AdminBadge.displayName = 'AdminBadge';

export default AdminBadge;
